import { whenNot } from 'platform/shared/health-apps';
import FacilityConfirmationPage from '../../../components/FormPages/FacilityConfirmation';
import FacilitySearchPage from '../../../components/FormPages/FacilitySearch';
import FacilityReview from '../../../components/FormReview/FacilityReview';
import { emptySchema } from '../../../definitions/sharedSchema';
import content from '../../../locales/en/content.json';
import { FORM_KEYS } from '../../../utils/constants';
import {
  facilityConfirmationNavBack,
  facilityLocatorNavBack,
  showFacilityConfirmation,
} from '../../../utils/helpers';
import contactInformation from './contactInformation';
import homeAddress from './homeAddress';
import identityInformation from './identityInformation';
import personalInformation from './personalInformation';
import vaMedicalCenter from './vaMedicalCenter';

const useFacilitiesApi = formData => formData[FORM_KEYS.facilitiesApi];

export const veteranPages = {
  veteranPersonalInfo: {
    path: 'veteran-information/personal-information',
    title: content['vet-info-title--personal'],
    ...personalInformation,
  },
  veteranIdentityInfo: {
    path: 'veteran-information/identity-information',
    title: content['vet-info-title--id'],
    ...identityInformation,
  },
  veteranAddress: {
    path: 'veteran-information/home-address',
    title: content['vet-info-title--address'],
    ...homeAddress,
  },
  veteranContactInfo: {
    path: 'veteran-information/contact-information',
    title: content['vet-info-title--contact'],
    ...contactInformation,
  },
  veteranMedicalCenter: {
    path: 'veteran-information/va-medical-center',
    title: content['vet-info-title--facility'],
    depends: whenNot(useFacilitiesApi),
    ...vaMedicalCenter,
  },
  veteranFacilityLocator: {
    path: 'veteran-information/va-medical-center/locator',
    title: content['vet-info-title--facility'],
    depends: useFacilitiesApi,
    CustomPage: FacilitySearchPage,
    CustomPageReview: FacilityReview,
    onNavBack: facilityLocatorNavBack,
    uiSchema: {},
    schema: emptySchema,
  },
  veteranFacilityConfirmation: {
    path: 'veteran-information/va-medical-center/confirm',
    title: content['vet-info-title--facility'],
    depends: showFacilityConfirmation,
    CustomPage: FacilityConfirmationPage,
    CustomPageReview: null,
    onNavBack: facilityConfirmationNavBack,
    uiSchema: {},
    schema: emptySchema,
  },
};
